import { PageHeader } from "./page-header";

interface SettingsPageProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: { label: string; href?: string }[];
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export function SettingsPage({
  title,
  subtitle,
  breadcrumbs,
  actions,
  children,
}: SettingsPageProps) {
  const crumbs = breadcrumbs ?? [{ label: "Settings" }, { label: title }];
  return (
    <>
      <PageHeader
        breadcrumbs={crumbs}
        title={title}
        subtitle={subtitle}
        actions={actions}
      />
      <div className="max-w-3xl space-y-8">{children}</div>
    </>
  );
}

interface SettingsSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
}

export function SettingsSection({
  title,
  description,
  children,
}: SettingsSectionProps) {
  return (
    <div className="space-y-4">
      {title && (
        <div>
          <h3 className="typo-heading text-[color:var(--color-text-hi)]">
            {title}
          </h3>
          {description && (
            <p className="mt-1 typo-body text-sm text-[color:var(--color-text-md)]">
              {description}
            </p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
